<template>
  <div v-if="visible" class="dialog-overlay" @click.self="handleClose">
    <div class="dialog-container">
      <!-- 头部 -->
      <div class="dialog-header">
        <h2 class="dialog-title">创建项目</h2>
        <div class="close-btn" @click="handleClose">
          <i class="el-icon-close"></i>
        </div>
      </div>

      <!-- 内容 -->
      <div class="dialog-body">
        <!-- 项目名称 -->
        <div class="form-item">
          <label class="form-label">项目名称</label>
          <el-input
            v-model="form.projectName"
            placeholder="请输入短剧项目名称"
            class="dark-input"
          ></el-input>
        </div>

        <!-- 叙事模式 -->
        <div class="form-item">
          <label class="form-label">叙事模式</label>
          <div class="mode-options">
            <div
              class="mode-option"
              :class="{ active: form.narrativeMode === '剧情模式' }"
              @click="form.narrativeMode = '剧情模式'"
            >
              <i class="el-icon-film"></i>
              <span>剧情模式</span>
              <el-tooltip
                class="mode-tooltip"
                content="70% 以上为对话场景，适合 AI短剧、情景喜剧、角色扮演"
                placement="top"
              >
                <i class="el-icon-question"></i>
              </el-tooltip>
            </div>
            <div
              class="mode-option"
              :class="{ active: form.narrativeMode === '旁白解说模式' }"
              @click="form.narrativeMode = '旁白解说模式'"
            >
              <i class="el-icon-microphone"></i>
              <span>旁白解说模式</span>
              <el-tooltip
                class="mode-tooltip"
                content="适合解说类短剧，具有完整的叙述框架"
                placement="top"
              >
                <i class="el-icon-question"></i>
              </el-tooltip>
            </div>
          </div>
        </div>

        <!-- 剧本导入 -->
        <div class="form-item">
          <div class="form-label-row">
            <label class="form-label">
              剧本导入
              <span class="optional-tag">（选填）</span>
            </label>
            <div class="ai-generate-btn" @click="handleAIGenerate">
              <i class="el-icon-magic-stick"></i>
              AI随机生成剧本
            </div>
          </div>
          <div class="script-textarea-wrapper">
            <el-input
              v-model="form.script"
              type="textarea"
              :rows="6"
              placeholder="请导入剧本，将为你自动分集（文本请用第n章/集分割）"
              class="dark-textarea"
              :maxlength="50000"
            ></el-input>
            <div class="char-count">{{ form.script.length }} / 50000</div>
          </div>
        </div>
      </div>

      <!-- 底部按钮 -->
      <div class="dialog-footer">
        <el-button class="cancel-btn" @click="handleClose">取消</el-button>
        <el-button class="submit-btn" :loading="loading" @click="handleSubmit">
          立即创建
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus, EVENTS } from "@/utils/eventBus";
import {
  ainewProjectadd,
  ainewProjectChapteradd,
  ainewProjectChapterlist,
  ainewChapterScriptadd,
} from "@/api/index";
export default {
  name: "CreateProjectDialog",
  data() {
    return {
      visible: false,
      loading: false,
      form: {
        projectName: "",
        narrativeMode: "drama",
        script: "",
      },
    };
  },
  created() {
    // 监听显示弹窗事件
    EventBus.$on(EVENTS.SHOW_CREATE_PROJECT, this.show);
    EventBus.$on(EVENTS.HIDE_CREATE_PROJECT, this.hide);
  },
  beforeDestroy() {
    // 移除事件监听
    EventBus.$off(EVENTS.SHOW_CREATE_PROJECT, this.show);
    EventBus.$off(EVENTS.HIDE_CREATE_PROJECT, this.hide);
  },
  methods: {
    show() {
      this.visible = true;
      this.resetForm();
    },
    hide() {
      this.visible = false;
    },
    resetForm() {
      this.form = {
        projectName: "",
        narrativeMode: "剧情模式",
        script: "",
      };
    },
    handleClose() {
      this.visible = false;
    },
    handleAIGenerate() {
      this.$message.info("AI正在生成剧本...");
      // TODO: 调用AI生成接口
      setTimeout(() => {
        this.form.script = `第1集：开篇

【场景：现代都市，繁华街道】

主角小明走在街上，手里拿着一封神秘的信...

第2集：转折

【场景：古老图书馆】

小明发现了一本古老的书籍，上面记载着惊人的秘密...`;
        this.$message.success("剧本生成成功");
      }, 1500);
    },
    handleSubmit() {
      if (!this.form.projectName.trim()) {
        this.$message.warning("请输入项目名称");
        return;
      }

      this.loading = true;
      console.log(this.form);
      const loading = this.$loading({
        lock: true,
        text: "创建中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      ainewProjectadd({
        userId: localStorage.getItem("userId"),
        projectName: this.form.projectName,
        type: this.form.narrativeMode,
        scriptContent: this.form.script,
      }).then((res) => {
        this.loading = false;
        this.$message.success("项目创建成功");
        this.visible = false;
        ainewProjectChapterlist({
          projectId: res.data.id,
          pageNum: 1,
          pageSize: 1,
        }).then((res1) => {
          if (res1.rows.length < 1) {
            // ainewChapterScriptadd
            ainewProjectChapteradd({
              projectId: res.data.id,
              chapterName: "第1章",
            }).then((res2) => {
              ainewChapterScriptadd({
                chapterId: res2.data.id,
                videoRatio: "16:9",
                scriptContent: this.form.script,
              }).then((res3) => {
                loading.close();
                // 跳转到项目编辑页面
                const newProjectId = res.data.id;
                this.$router.push({
                  name: "Editor",
                  params: { id: newProjectId },
                  // query: { name: this.form.projectName, mode: this.form.narrativeMode },
                });
              });
            });
          } else {
            loading.close();
            // 跳转到项目编辑页面
            const newProjectId = res.data.id;
            this.$router.push({
              name: "Editor",
              params: { id: newProjectId },
              // query: { name: this.form.projectName, mode: this.form.narrativeMode },
            });
          }
        });
      });

      // TODO: 调用创建项目接口
      // setTimeout(() => {
      //   this.loading = false;
      //   this.$message.success("项目创建成功");
      //   this.visible = false;

      //   // 跳转到项目编辑页面
      //   const newProjectId = Date.now();
      //   this.$router.push({
      //     name: "Editor",
      //     params: { id: newProjectId },
      //     query: { name: this.form.projectName, mode: this.form.narrativeMode },
      //   });
      // }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  backdrop-filter: blur(4px);
}

.dialog-container {
  width: 560px;
  max-width: 90vw;
  max-height: 90vh;
  background-color: #1e1e1e;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #2d2d2d;
}

.dialog-title {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  margin: 0;
}

.close-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #2d2d2d;
  }

  i {
    font-size: 18px;
    color: #888;
  }
}

.dialog-body {
  padding: 24px;
  overflow-y: auto;
  flex: 1;
}

.form-item {
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
}

.form-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  margin-bottom: 12px;
}

.form-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.optional-tag {
  color: #666;
  font-weight: 400;
}

.ai-generate-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background-color: transparent;
  border: 1px solid #8bff8b;
  border-radius: 6px;
  color: #8bff8b;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: rgba(139, 255, 139, 0.1);
  }

  i {
    font-size: 14px;
  }
}

/* 深色输入框样式 */
.dark-input {
  :deep(.el-input__inner) {
    background-color: #2d2d2d;
    border: 1px solid #3d3d3d;
    color: #fff;
    height: 44px;
    border-radius: 8px;
    font-size: 14px;
    caret-color: #8bff8b;

    &::placeholder {
      color: #666;
    }

    &:hover {
      border-color: #4d4d4d;
    }

    &:focus {
      border-color: #8bff8b;
      box-shadow: 0 0 0 2px rgba(139, 255, 139, 0.1);
    }
  }
}

/* 模式选项样式 */
.mode-options {
  display: flex;
  gap: 16px;
}

.mode-option {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 14px 20px;
  background-color: #2d2d2d;
  border: 2px solid #3d3d3d;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #888;
  position: relative;

  &:hover {
    border-color: #4d4d4d;
    color: #fff;
  }

  &.active {
    border-color: #8bff8b;
    color: #fff;
    background-color: rgba(139, 255, 139, 0.05);
  }

  i:first-child {
    font-size: 18px;
  }

  span {
    font-size: 14px;
    font-weight: 500;
  }

  .mode-tooltip {
    :deep(.el-tooltip__popper) {
      background-color: #2d2d2d;
      border-color: #3d3d3d;
      color: #fff;
      font-size: 12px;
      padding: 8px 12px;

      &[x-placement^="top"] .popper__arrow::after {
        border-top-color: #2d2d2d;
      }
    }
  }

  .el-icon-question {
    font-size: 14px;
    color: #666;
    cursor: help;

    &:hover {
      color: #888;
    }
  }
}

/* 剧本文本域 */
.script-textarea-wrapper {
  position: relative;
}

.dark-textarea {
  :deep(.el-textarea__inner) {
    background-color: #2d2d2d;
    border: 1px solid #3d3d3d;
    color: #fff;
    border-radius: 8px;
    padding: 12px;
    resize: none;
    font-size: 14px;
    caret-color: #8bff8b;
    line-height: 1.5;

    &::placeholder {
      color: #666;
    }

    &:hover {
      border-color: #4d4d4d;
    }

    &:focus {
      border-color: #8bff8b;
      box-shadow: 0 0 0 2px rgba(139, 255, 139, 0.1);
    }
  }
}

.char-count {
  position: absolute;
  bottom: 12px;
  right: 12px;
  font-size: 12px;
  color: #666;
}

/* 底部按钮 */
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #2d2d2d;
}

.cancel-btn {
  padding: 10px 24px;
  background-color: transparent;
  border: 1px solid #3d3d3d;
  color: #fff;
  border-radius: 8px;

  &:hover {
    background-color: #2d2d2d;
    border-color: #4d4d4d;
  }
}

.submit-btn {
  padding: 10px 24px;
  background-color: #8bff8b !important;
  border: none !important;
  color: #1a1a1a !important;
  border-radius: 8px;
  font-weight: 600;

  &:hover {
    background-color: #7aee7a !important;
  }
}
</style>
